import React from 'react';
export function PainPointsSection() {
  const painPoints = ['Domingo a la noche buscando actividades que nunca quedan como querés', 'Planificaciones que armás a las corridas porque dirección las pide para el lunes', 'Evaluaciones inventadas en el último momento sin criterios ni rúbricas claras', 'Horas perdidas adaptando materiales que no respetan el currículo argentino', 'Los actos patrios que te agarran sin preparación y tenés que resolver todo en dos días', 'Mapas, líneas de tiempo y proyectos que tenés que diseñar desde cero cada año', 'El chico con rezago que no podés atender bien porque no tenés actividades diferenciadas', 'La directora pidiendo el proyecto de ESI y vos sin saber por dónde arrancar'];
  return <section className="bg-brand-dark py-16 md:py-24 px-4 border-t border-brand-border" data-id="element-186">
      <div className="max-w-3xl mx-auto" data-id="element-187">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-white text-center mb-10 md:mb-14 leading-snug px-2" data-id="element-188">
          Si sos docente de primaria en Argentina,
          <br data-id="element-189" />
          <span className="text-brand-accent" data-id="element-190">
            esto te va a sonar familiar:
          </span>
        </h2>
        <div className="space-y-4 md:space-y-5 mb-14 md:mb-16" data-id="element-191">
          {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 md:gap-5 py-5 md:py-6 px-5 md:px-7 rounded-2xl bg-[#2a1a1a] border border-[#5a4a2a]" data-id="element-192">
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 bg-brand-red/20 rounded-lg flex items-center justify-center text-brand-red font-black text-lg md:text-xl" data-id="element-193">
                ✕
              </div>
              <p className="text-base sm:text-lg md:text-xl text-white/90 font-semibold leading-snug" data-id="element-194">
                {point}
              </p>
            </div>)}
        </div>
        <div className="text-center px-4" data-id="element-195">
          <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold leading-tight italic text-[#FF4D33]" data-id="element-196">
            ¿Cuántos domingos más vas a perder haciendo lo mismo?
          </p>
        </div>
      </div>
    </section>;
}